// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-container {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000007;
}

.popup-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  height: 30%;
  background-color: #fff;
  /* border-radius: 9px; */
  padding: 1rem;
  z-index: 1;
}

.popup-title {
  position: relative;
  font-size: 1.6rem;
}

.popup-sub-text {
  position: relative;
  display: none;
  font-size: 1rem;
}

.popup-continue-button {
  position: absolute;
  display: none;
  left: 1rem;
  bottom: 1rem;
  text-align: center;
  padding: 0.5rem 1.2rem;
  background-color: #333;
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
}

.popup-continue-button:hover {
  background-color: #444;
}

.popup-continue-button:active {
  background-color: #111;
}

.sound-calibration-background {
  background-color: #fff;
  position: absolute;
  width: 40%;
  top: 10% !important;
}

/* -------------------------------------------------------------------------- */

/* question and answer */

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate3d(0, 10%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fade-in {
  animation-name: fadeIn;
  animation-duration: 0.3s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}

.swal2-container {
  background: #eaeaea !important;
}

.swal2-container.no-background {
  background: rgba(0, 0, 0, 0.5) !important;
}

.swal2-popup {
  width: 80%;
  cursor: default;
  opacity: 1;
  background: #fff;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.swal2-title {
  color: #000 !important;
  font-size: 1.6rem;
  font-weight: 500;
  margin: 3rem 2.5rem 1rem;
  padding: 0;
  user-select: none;
  text-align: left;
}

.swal2-radio {
  color: #000;
  flex-direction: column;
  font-weight: 500;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.swal2-radio .swal2-label {
  margin-left: 1rem;
  font-size: 1.5rem;
  line-height: 150%;
  user-select: none;
}

.swal2-radio label {
  width: 80% !important;
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
  margin: 0.3rem 0 !important;
  font-size: 1.5rem !important;
  cursor: pointer !important;
  padding: 0.5rem !important;
  background-color: #ddd !important;
  border-radius: 7px !important;
}

.swal2-radio label:hover {
  outline: 2px solid #aaa !important;
  outline-offset: 0.2rem !important;
}

.swal2-radio label:has(input[type="radio"]:checked) {
  background-color: #aaa;
  /* border-left: 5px solid #333; */
}

.swal2-radio label input {
  display: none;
}

.swal2-textarea {
  resize: none;
  border-radius: 7px;
  height: 7rem;
}

.swal2-confirm {
  background-color: #333 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 7px !important;
  /* margin: 1rem !important; */
  display: block;
  position: relative !important;
}

.hidden-button {
  display: none !important;
}

/* -------------------------------------------------------------------------- */

.swal2-input {
  font-family: Courier, monospace;
  font-size: 2rem;
  margin: 1rem 4rem 0;
}

.swal2-input-label,
.swal2-html-container {
  margin: 2rem 4rem 0;
  /* text-align: left; */
  line-height: 150%;
}

.swal2-cancel,
.swal2-deny {
  border-radius: 7px !important;
}

.swal2-file {
  padding: 1rem;
}

/* ----------------------------- special classes ---------------------------- */

.id-collection-popup .threshold-button {
  position: relative;
}

.centered-title {
  text-align: center;
}

.narrow-popup {
  width: 60% !important;
}
`, "",{"version":3,"sources":["webpack://./components/css/popup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E,wBAAwB;;AAExB;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sCAAsC;EACtC,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+EAA+E;;AAE/E;EACE,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".popup-container {\n  display: none;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000007;\n}\n\n.popup-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: -1;\n}\n\n.popup {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 40%;\n  height: 30%;\n  background-color: #fff;\n  /* border-radius: 9px; */\n  padding: 1rem;\n  z-index: 1;\n}\n\n.popup-title {\n  position: relative;\n  font-size: 1.6rem;\n}\n\n.popup-sub-text {\n  position: relative;\n  display: none;\n  font-size: 1rem;\n}\n\n.popup-continue-button {\n  position: absolute;\n  display: none;\n  left: 1rem;\n  bottom: 1rem;\n  text-align: center;\n  padding: 0.5rem 1.2rem;\n  background-color: #333;\n  color: #fff;\n  outline: none;\n  border: none;\n  cursor: pointer;\n}\n\n.popup-continue-button:hover {\n  background-color: #444;\n}\n\n.popup-continue-button:active {\n  background-color: #111;\n}\n\n.sound-calibration-background {\n  background-color: #fff;\n  position: absolute;\n  width: 40%;\n  top: 10% !important;\n}\n\n/* -------------------------------------------------------------------------- */\n\n/* question and answer */\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 10%, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.fade-in {\n  animation-name: fadeIn;\n  animation-duration: 0.3s;\n  animation-timing-function: ease-in-out;\n  animation-fill-mode: forwards;\n}\n\n.swal2-container {\n  background: #eaeaea !important;\n}\n\n.swal2-container.no-background {\n  background: rgba(0, 0, 0, 0.5) !important;\n}\n\n.swal2-popup {\n  width: 80%;\n  cursor: default;\n  opacity: 1;\n  background: #fff;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n}\n\n.swal2-title {\n  color: #000 !important;\n  font-size: 1.6rem;\n  font-weight: 500;\n  margin: 3rem 2.5rem 1rem;\n  padding: 0;\n  user-select: none;\n  text-align: left;\n}\n\n.swal2-radio {\n  color: #000;\n  flex-direction: column;\n  font-weight: 500;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.swal2-radio .swal2-label {\n  margin-left: 1rem;\n  font-size: 1.5rem;\n  line-height: 150%;\n  user-select: none;\n}\n\n.swal2-radio label {\n  width: 80% !important;\n  display: flex !important;\n  justify-content: flex-start !important;\n  align-items: center !important;\n  margin: 0.3rem 0 !important;\n  font-size: 1.5rem !important;\n  cursor: pointer !important;\n  padding: 0.5rem !important;\n  background-color: #ddd !important;\n  border-radius: 7px !important;\n}\n\n.swal2-radio label:hover {\n  outline: 2px solid #aaa !important;\n  outline-offset: 0.2rem !important;\n}\n\n.swal2-radio label:has(input[type=\"radio\"]:checked) {\n  background-color: #aaa;\n  /* border-left: 5px solid #333; */\n}\n\n.swal2-radio label input {\n  display: none;\n}\n\n.swal2-textarea {\n  resize: none;\n  border-radius: 7px;\n  height: 7rem;\n}\n\n.swal2-confirm {\n  background-color: #333 !important;\n  color: #fff !important;\n  border: none !important;\n  border-radius: 7px !important;\n  /* margin: 1rem !important; */\n  display: block;\n  position: relative !important;\n}\n\n.hidden-button {\n  display: none !important;\n}\n\n/* -------------------------------------------------------------------------- */\n\n.swal2-input {\n  font-family: Courier, monospace;\n  font-size: 2rem;\n  margin: 1rem 4rem 0;\n}\n\n.swal2-input-label,\n.swal2-html-container {\n  margin: 2rem 4rem 0;\n  /* text-align: left; */\n  line-height: 150%;\n}\n\n.swal2-cancel,\n.swal2-deny {\n  border-radius: 7px !important;\n}\n\n.swal2-file {\n  padding: 1rem;\n}\n\n/* ----------------------------- special classes ---------------------------- */\n\n.id-collection-popup .threshold-button {\n  position: relative;\n}\n\n.centered-title {\n  text-align: center;\n}\n\n.narrow-popup {\n  width: 60% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
